'use client'

import type { SupporterResponseState } from '@/components/blocks/supporter-response'

import { MessengerLogoIcon } from '@/components/icons/icon-set'
import { AppShell } from '@/components/blocks/app-layout'
import { SupporterResponseWorkspace } from '@/components/blocks/supporter-response'

/*
 * GoodUnited / Supporter Response templates. Figma: 33 / Templates / Supporter Response.
 * The inbox in AppShell, in the three states from Figma: a Messenger draft, a message sent and an email
 * marked as sent. writing-style opens the writing-style settings over the inbox. Every template is live:
 * pick a conversation, edit and send the reply, mark it done, manage tags and open the settings.
 */
export type SupporterResponseTemplateKind = SupporterResponseState | 'writing-style'

export const SUPPORTER_RESPONSE_TEMPLATES: { kind: SupporterResponseTemplateKind, title: string, description: string }[] = [
    { kind: 'draft', title: 'Messenger draft', description: 'GoodUnited AI drafted a reply. Edit it, switch to email or send it on Messenger.' },
    { kind: 'sent', title: 'Message sent', description: 'The reply went out and the conversation is marked as done. Write another reopens the composer.' },
    { kind: 'email-marked-sent', title: 'Email marked as sent', description: 'The reply was copied into an email and the conversation is marked as done.' },
    { kind: 'writing-style', title: 'Writing-style settings', description: 'Voice and tone, nonprofit details, brand files and websites, opened from Set up your writing style.' }
]

export function SupporterResponseTemplate({ kind = 'draft' }: { kind?: SupporterResponseTemplateKind }) {
    return (
        <AppShell title='Supporter Response' icon={<MessengerLogoIcon />} activeItem='supporter-response'>
            <SupporterResponseWorkspace
                state={kind === 'writing-style' ? 'draft' : kind}
                writingStyleOpen={kind === 'writing-style'}
            />
        </AppShell>
    )
}
